// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import DangerSvg from '@rsuite/icon-font/lib/application/Danger';
var Danger = createSvgIcon({
  as: DangerSvg,
  ariaLabel: 'danger',
  category: 'application',
  displayName: 'Danger'
});
export default Danger;